import React from "react";
import AllData from "../../components/hotel_table/table/component";

const Component = () => {
  return <AllData tableHeading="Hotel QR Tables" />;
};

export default Component;
